<style lang="scss">
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/mixins";

  .floating-ui {
    position: fixed;

    &.dropdown {
      display: flex;
      flex-direction: column;
      padding: utils.in_rem(8px);
      background-color: white;
      border: 1px solid colors.get(interfaceSwGrey_5);
      border-radius: 16px;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
      z-index: 102; // needs to be >101 to be above datatable tHead when pageSize = 100
    }

    &.sw-svelte-tooltip,
    &.toggletip {
      display: flex;
      justify-content: center;
      align-items: center;
      backdrop-filter: blur(4px);
      border-radius: 8px;
      display: flex;
      padding: utils.in_rem(12px);
      position: fixed;
      justify-content: center;
      z-index: 99;
      @include colors.background-color(interfaceTransparentBlack_85);
      @include colors.color(textWhite);
      @include mixins.body4-tooltip();
    }

    &.z-index-1 {
      z-index: 1;
    }
  }
</style>

<script>
  import {
    autoUpdate,
    computePosition,
    flip,
    offset,
    shift,
    size,
  } from "@floating-ui/dom";

  let cls = "";
  export { cls as class };

  export let placement = undefined;
  export let referenceEl;

  export let style = "";
  export let role = ""; // for A11y, a nice touch if you provide it.
  let enableFlip = true; // pass false to disable automatic flipping on filtering
  export { enableFlip as flip };

  /** @type {HTMLElement} */
  export let floatingEl;

  export let onmouseenter = () => {};
  export let onmouseleave = () => {};

  export let escape = () => {}; // optional action to apply to element.

  const onclick = (e) => {
    e.stopPropagation();
  };

  $: middleware = [
    offset(8),
    ...(enableFlip ? [flip({ padding: 8 })] : []),
    shift({ padding: 8, boundary: "viewport" }),
    size({
      padding: 8,
      apply: ({ availableWidth, availableHeight, elements }) => {
        Object.assign(elements.floating.style, {
          maxWidth: `${Math.max(0, availableWidth)}px`,
          maxHeight: `${Math.max(0, availableHeight)}px`,
        });
      },
    }),
  ];

  const action = (el) => {
    const setPosition = () =>
      computePosition(referenceEl, el, {
        placement,
        middleware,
        strategy: "fixed",
      }).then(({ x, y }) => {
        el.style.top = `${y}px`;
        el.style.left = `${x}px`;
      });
    setPosition();

    const update = () => {
      if (!(referenceEl && el)) return;
      requestAnimationFrame(setPosition);
    };

    const destroy = autoUpdate(referenceEl, el, update);
    return {
      destroy,
    };
  };
</script>

<div
  {style}
  class="floating-ui {cls}"
  use:action
  use:escape
  bind:this={floatingEl}
  {role}
  on:mouseenter={onmouseenter}
  on:mouseleave={onmouseleave}
  on:click={onclick}
>
  <slot />
</div>
